export const offsetParent = (e) => e && e.offsetParent;
export const offsetParents = (e) => (offsetParent(e) ? [e].concat(offsetParents(offsetParent(e))) : [e]);
